import { useCallback } from 'react';
import { Edge } from 'reactflow';
import { useFlowNodePersist } from '../../../ThirdPartyIntegration/hooks/useFlowNodePersist';
import { checkExecuteTrigger } from '../../../../util/checkExecute';

type SetSaving = (saving: {
  lastSaved?: string;
  status: string;
  finished?: boolean;
  flowId?: string;
}) => void;

type SetSchema = (
  schema: Record<string, { type: string; required: boolean }>,
) => void;

export function useMcpNodePersist(
  edges: Edge[],
  id: string,
  flowId: string | undefined,
  nodeData: Record<string, unknown>,
  setNodeState: (value: unknown) => void,
  setSaving: SetSaving,
  setSchema: SetSchema,
) {
  const persist = useFlowNodePersist(
    edges,
    id,
    flowId,
    setNodeState,
    setSaving,
    setSchema,
  );

  return useCallback(
    (object: Record<string, unknown>, changeType: string = 'default') => {
      const asRecord: Record<string, unknown> = { ...object };
      persist(asRecord, {
        flowTriggerData: checkExecuteTrigger(nodeData, id),
        changeType,
      });
    },
    [persist, nodeData, id],
  );
}
